export const SAVE_DATA_REDUX = 'SAVE_DATA_REDUX';
export const RESET_DATA_REDUX = 'RESET_DATA_REDUX';

export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';
export const UPDATE_APPLICATION_ROUTE = 'UPDATE_APPLICATION_ROUTE';
export const SET_COVIE_DATA = 'SET_COVIE_DATA';
export const SET_COMPLIANCE_ERROR = 'SET_COMPLIANCE_ERROR';
